jQuery(document).ready(function () {
  if ($(".offres").length > 0) {
    var allReal = $(".offres_job-link");
    var itemToDisplay = 9;
    var thematique;
    var allItem = allReal.length;

    function defineCardToDisplay() {
      if (allItem > itemToDisplay) {
        $(".offres_showMore").show();
      }

      $(".offres_job-link:lt(" + itemToDisplay + ")").show();

      $(".offres_showMore").click(function () {
        itemToDisplay = itemToDisplay + 9;

        if (thematique == undefined) {
          $(".offres_job-link:lt(" + itemToDisplay + ")").show();
        } else {
          $(".offres_job-" + thematique + ":lt(" + itemToDisplay + ")").show();
        }
        if (allItem <= itemToDisplay) {
          $(".offres_showMore").hide();
        }
      });
    }
    defineCardToDisplay();

    $(".offres_filterItem").click(function () {
      $(".offres_filterItem").removeClass("offres_filterItem-active");
      $(this).toggleClass("offres_filterItem-active");
      thematique = $(this).attr("id");
      var thematiqueItem = $(".offres_job-" + thematique).length;
      allItem = thematiqueItem;
      if (thematiqueItem <= itemToDisplay) {
        $(".offres_showMore").hide();
      } else {
        $(".offres_showMore").show();
      }
      allReal.hide();
      var count = 0;
      allReal.each(function (index) {
        if ($(this).data(thematique)) {
          if (count < itemToDisplay) {
            $(this).show();
            count++;
          }
        }
      });
    });

    function filterOption() {
      var allcategory = $(".offres_categorie-title");
      var categoryTab = [];
      allcategory.each(function () {
        categoryTab.push($(this).text());
      });
      const unique = (arr) => [...new Set(arr)];

      categoryTab = unique(categoryTab);

      var selectDrop = $(".offres_filter-dropdown");
      for (var i = 0; i < categoryTab.length; i++) {
        var category = categoryTab[i];
        category = category.trim();
        const test = $(".uxui");
        $.each(test.data(), function (i) {
          test.removeAttr("data-" + i);
        });
        test.attr("data-uxui", "1");
        test.addClass("offres_job-uxui");

        var option = document.createElement("option");
        option.setAttribute("value", "category");
        option.textContent = category;
        option.value = category;
        selectDrop.append(option);
      }

      /* Filter with change on select */

      selectDrop.on("change", function () {
        thematique = this.value;
        allReal.hide();
        var thematiqueItem = $(".offres_job-" + thematique).length;
        allItem = thematiqueItem;
        if (thematique == "") {
          $(".offres_job-link:lt(" + itemToDisplay + ")").show();
        } else {
          $(".offres_job-" + thematique + ":lt(" + itemToDisplay + ")").show();
        }
        if (allItem <= itemToDisplay) {
          $(".offres_showMore").hide();
        } else {
          $(".offres_showMore").show();
        }
      });
    }
    filterOption();

    // filter with keyword

    function filterKeyword() {
      var input, filter, ul, li, title, i, txtValue;
      input = $(".offres_filter-searchBar");
      input.on("input", function () {
        filter = input.val().toUpperCase();
        ul = $(".offres_list");
        li = $(".offres_job-link");
        li.each(function () {
          title = $(this).find("div.offres_job")[0];
          txtValue = title.textContent || title.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            $(this)[0].style.display = "inline";
          } else {
            $(this)[0].style.display = "none";
          }
        });
      });
    }
    filterKeyword();
  }
});
